import { Component } from '@angular/core';
import { ListCreaturePage } from '../creature/list/list-creature.page';

@Component({
  selector: 'marketplace-page',
  templateUrl: './marketplace.page.html',
  styleUrl: './marketplace.page.scss',
  imports: [
    ListCreaturePage
  ]
})
export class MarketplacePage {

}